// 子仓库-用户管理
import to from 'await-to-js';
import * as apis from "@/api/interface/user";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    monitorMenuList: undefined, //monitor菜单配置 - 列表
    monitorReportList: undefined, //monitor报表配置 - 列表
    monitorTheadList: undefined, //monitor表头配置 - 列表
    monitorRoleList: undefined, //monitor角色配置 - 列表
    userList: undefined, //用户配置 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // monitor菜单配置 - 列表
    async getMonitorMenuList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMonitorMenuList(payload));
      ctx.commit("update", {
        monitorMenuList: !err && res.data ? res.data : undefined,
      });
    },
    // monitor菜单配置 - 新增、修改
    async monitorMenuAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.monitorMenuAddOrUpdate(payload));
      return res;
    },
    // monitor菜单配置 - 删除
    async monitorMenuDelete(ctx, payload = {}) {
      const [, res] = await to(apis.monitorMenuDelete(payload));
      return res;
    },



    // monitor报表配置 - 菜单选项
    async getMonitorReportMenuOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getMonitorMenuList(payload));
      return res;
    },
    // monitor报表配置 - 列表
    async getMonitorReportList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMonitorReportList(payload));
      ctx.commit("update", {
        monitorReportList: !err && res.data ? res.data : undefined,
      }); 
    },
    // monitor报表配置 - 新增、修改
    async monitorReportAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.monitorReportAddOrUpdate(payload));
      return res;
    },
    // monitor报表配置 - 删除
    async monitorReportDelete(ctx, payload = {}) {
      const [, res] = await to(apis.monitorReportDelete(payload));
      return res;
    },



    // monitor表头配置 - 报表选项
    async getMonitorTheadReportOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getMonitorReportList(payload));
      return res;
    },
    // monitor表头配置 - 表头选项
    async getMonitorTheadOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getMonitorTheadList(payload));
      return res;
    },
    // monitor表头配置 - 列表
    async getMonitorTheadList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMonitorTheadList(payload));
      ctx.commit("update", {
        monitorTheadList: !err && res.data ? res.data : undefined,
      });
    },
    // monitor表头配置 - 新增、修改
    async monitorTheadAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.monitorTheadAddOrUpdate(payload));
      return res;
    },
    // monitor表头配置 - 删除
    async monitorTheadDelete(ctx, payload = {}) {
      const [, res] = await to(apis.monitorTheadDelete(payload));
      return res;
    },



    // monitor角色配置 - 智保云菜单选项
    // async getMonitorRoleZbyMenuOptions(ctx, payload = {}) {
    //   const [, res] = await to (apis.getMonitorRoleZbyMenuOptions(payload));
    //   return res;
    // },
    // monitor角色配置 - 列表
    async getMonitorRoleList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMonitorRoleList(payload));
      ctx.commit("update", {
        monitorRoleList: !err && res.data ? res.data : undefined,
      });
    },
    // monitor角色配置 - 新增、修改
    async monitorRoleAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.monitorRoleAddOrUpdate(payload));
      return res;
    },
    // monitor角色配置 - 删除
    async monitorRoleDelete(ctx, payload = {}) {
      const [, res] = await to(apis.monitorRoleDelete(payload));
      return res;
    },



    // 用户配置 - 角色选项
    async getRoleOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getRoleList(payload));
      return res;
    },
    // 用户配置 - monitor角色选项
    async getMonitorRoleOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getMonitorRoleList(payload));
      return res;
    },
    // 用户配置 - 列表
    async getUserList(ctx, payload = {}) {
      const [err, res] = await to (apis.getUserList(payload));
      ctx.commit("update", {
        userList: !err && res.data ? res.data : undefined,
      });
    },
    // 用户配置 - 新增、修改
    async userAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.userAddOrUpdate(payload));
      return res;
    },
    // 用户配置 - 删除
    async userDelete(ctx, payload = {}) {
      const [, res] = await to(apis.userDelete(payload));
      return res;
    },
  },
  modules: {},
};
